// site management
export const getSiteManagementSelectedSiteData = state => state.persistReducers.siteManagementSelectedSite.data;

// ticket request 
export const getTicketRequestSelectedSiteData = state => state.persistReducers.ticketRequestSelectedSite.data;

// console tab switch
export const getConsoleTabSwitchData = state => state.persistReducers.consoleTabSwitch.data;